<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <product-field
          v-model="form.main.pr_detail"
          @select="onMainSelectProduct($event, form.main)"
          :label="customLabel.pr_detail"
          slot="pr_detail"
        />
        <make-kind-field
          :label="'制造类型'"
          :path="'/MAKEDISASSEMBLE'"
          v-model="form.main.md_type"
          @select="onSelectMakeKind($event, form.main)"
          slot="md_type"
        />
        <div class="weui-cell" slot="md_type">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.md_type || "制造类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ "拆解" }}
          </div>
        </div>
        <div class="weui-cell" slot="md_qty">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.md_qty || "数量"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.md_qty"
              placeholder="0"
            />
          </div>
        </div>
        <date-field
          slot="md_planbegindate"
          :label="customLabel.md_planbegindate || '开工日期'"
          v-model="form.main.md_planbegindate"
        />
        <date-field
          slot="md_planenddate"
          :label="customLabel.md_planenddate || '完工日期'"
          v-model="form.main.md_planenddate"
        />
        <combo-field slot="md_wcname"
          :label="customLabel.md_wcname || '工作中心'"
          v-model="form.main.md_wcname"
          url="/api/document/workcenter/getCombo"
        />
        <custom-field 
          :label="customLabel.md_text1 || '自定义字段1'"
          v-model="form.main.md_text1" :caller="caller" fieldName="md_text1"
          slot="md_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.md_text2 || '自定义字段2'"
          v-model="form.main.md_text2" :caller="caller" fieldName="md_text2"
          slot="md_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.md_text3 || '自定义字段3'"
          v-model="form.main.md_text3" :caller="caller" fieldName="md_text3"
          slot="md_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.md_text4 || '自定义字段4'"
          v-model="form.main.md_text4" :caller="caller" fieldName="md_text4"
          slot="md_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.md_text5 || '自定义字段5'"
          v-model="form.main.md_text5" :caller="caller" fieldName="md_text5"
          slot="md_text5" hidden="true"
        />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
             v-model="item.pr_detail"
              @select="onItemSelectProduct($event, item)"
              :label="customLabel.pr_detail"
              slot="pr_detail"
            />
            <div
              class="weui-cell"
              v-if="item.pr_orispeccode"
              slot="pr_orispeccode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_orispeccode || "型号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.pr_orispeccode }}
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="item.pr_spec"
              slot="pr_spec"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_spec || "规格"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.pr_spec }}</div>
            </div>
            <div class="weui-cell" slot="dd_oneuseqty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_oneuseqty || "单位用量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.dd_oneuseqty"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_qty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_qty || "拆解数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ (form.main.md_qty * item.dd_oneuseqty) || 0 }}
              </div>
            </div>
            <div class="weui-cell" slot="dd_batchcode">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_batchcode || "批次号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_batchcode"
                  placeholder="请填写"
                />
              </div>
            </div>
            <date-field
              :label="customLabel.dd_madetime || '生产日期'"
              v-model="item.dd_madetime"
              slot="dd_madetime"
            />
            <div class="weui-cell" slot="dd_shelflife">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_shelflife || "保质期（天）"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.dd_shelflife"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="dd_remark">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.dd_remark || "备注"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.dd_remark"
                  placeholder="请填写"
                />
              </div>
            </div>
            <custom-field 
              :label="customLabel.dd_text1 || '自定义字段1'"
              v-model="item.dd_text1" :caller="caller" fieldName="dd_text1"
              slot="dd_text1" hidden="true"
            />
            <custom-field
              :label="customLabel.dd_text2 || '自定义字段2'"
              v-model="item.dd_text2" :caller="caller" fieldName="dd_text2"
              slot="dd_text2" hidden="true"
            />
            <custom-field 
              :label="customLabel.dd_text3 || '自定义字段3'"
              v-model="item.dd_text3" :caller="caller" fieldName="dd_text3"
              slot="dd_text3" hidden="true"
            />
            <custom-field 
              :label="customLabel.dd_text4 || '自定义字段4'"
              v-model="item.dd_text4" :caller="caller" fieldName="dd_text4"
              slot="dd_text4" hidden="true"
            />
            <custom-field 
              :label="customLabel.dd_text5 || '自定义字段5'"
              v-model="item.dd_text5" :caller="caller" fieldName="dd_text5"
              slot="dd_text5" hidden="true"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ProductField from "@/components/field/ProductField.vue";
import MakeKindField from "@/components/field/MakeKindField.vue";
import ComboField from "@/components/field/ComboField.vue";
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    ProductField,
    MakeKindField,
    ComboField,
    DateField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/make/makeDisassemble",
      codeField: "md_code",
      statusField: "md_statuscode",
      caller: "MakeDisassemble",
      xtype: "make-makeDisassemble-formpanel",
      form: {
        main: {

        },
        items: [
          {

          },
        ],
      },
    };
  },
  methods: {
    onMainSelectProduct(selection, main) {
      main.md_prodid = selection.id;
      main.md_proddetail = selection.pr_detail;
      main.md_prodcode = selection.pr_code;
      main.pr_orispeccode = selection.pr_orispeccode;
      main.pr_detail = selection.pr_detail;
      main.pr_brand = selection.pr_brand;
      main.pr_spec = selection.pr_spec;
    },
    onSelectMakeKind(selection, main) {
      main.md_tasktypeid = selection.id
      main.md_tasktype = selection.mk_makind
    },
    /**
     * 选择明细产品
     */
    onItemSelectProduct(selection, item) {
      item.dd_prodid = selection.id;
      item.dd_prodcode = selection.pr_code;
      item.pr_detail = selection.pr_detail;
      item.pr_brand = selection.pr_brand;
      item.pr_orispeccode = selection.pr_orispeccode;
      item.pr_spec = selection.pr_spec;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.md_prodcode) {
        me.$weui.topTips("请选择产品", 2000);
      } else if (!main.md_qty) {
        me.$weui.topTips("请填写数量", 2000);
      } else if (!main.md_planbegindate) {
        me.$weui.topTips("请选择开工日期", 2000);
      } else if (!main.md_planenddate) {
        me.$weui.topTips("请选择完工日期", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.dd_oneuseqty) {
            me.$weui.topTips(`第${count + 1}行单位用量未填写`, 2000);
            return false;
          } else {
            count++;
            item.dd_qty = main.md_qty * item.dd_oneuseqty;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({

      });
    },
  },
};
</script>